"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var ShopGuarantee = function () {
    return ((0, preact_1.h)("div", { class: "shop-v2__happiness-guarantee-container" },
        (0, preact_1.h)("p", { class: "shop-v2__happiness-guarantee" }, "60-Day Money-Back Guarantee")));
};
exports.default = ShopGuarantee;
